import { Component, OnInit } from '@angular/core';
import {
  HealthEducation,
  PaginationOptions,
} from 'src/app/@resources/graphql/types/types';
import { HealthEducationService } from 'src/app/@resources/services/health-education.service';
import { LocalStorageService } from 'src/app/@resources/services/local-storage.service';
import { SeoService } from '../../../@resources/services/SEO.service';
import AOS from 'aos';

@Component({
  selector: 'app-health-education-list',
  templateUrl: './health-education-list.component.html',
  styleUrls: ['./health-education-list.component.scss'],
})
export class HealthEducationListComponent implements OnInit {
  helathEducations: HealthEducation[];

  paginationOptions: PaginationOptions = { limit: 0, page: 0 };

  constructor(
    private healthEducationService: HealthEducationService,
    private readonly seoService: SeoService,
    private localStorage: LocalStorageService
  ) {}

  ngOnInit(): void {
    AOS.init();
    this.helathEducationsData();
    this.setTitle();
  }
  setTitle() {
    const lang = this.localStorage.get('lang');
    lang == 'en'
      ? this.seoService.updateTitle('Health education')
      : this.seoService.updateTitle('التثقيف الصحي');
  }
  helathEducationsData() {
    this.healthEducationService
      .listHealthEducations(this.paginationOptions)
      .subscribe((res: any) => {
        this.helathEducations = res.data.healthEducations;
      });
  }
}
